import { useNavigate } from 'react-router-dom';
import { useMemo, useState } from 'react';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { Offer } from '../../interfaces/Offer/Offer';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { offerTypeNameMap } from '../../interfaces/Offer/OfferType';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { BoolColumn } from '../../components/DataTable/BoolColumn';
import { paginateRows } from '../../utils/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';
import { sharedColors } from '../../utils/Style';

const rowColorizer = (offer: Offer): string => {
  if (offer.startAt > new Date()) return sharedColors.blue1;
  if (offer.startAt < new Date() && offer.endAt > new Date() && offer.isActive)
    return sharedColors.statusGreenLightest;

  return sharedColors.statusRedLightest;
};

const columns: TableColumn<Offer>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'type',
    name: 'Tür',
    accessor: (row) => (
      <TextColumn value={offerTypeNameMap[row.type] ?? 'Bilinmeyen'} />
    ),
  },
  {
    id: 'name',
    name: 'İsim',
    accessor: (row) => <TextColumn value={row.name} />,
  },
  {
    id: 'start-at',
    name: 'Başlangıç',
    accessor: (row) => <DateColumn value={row.startAt} />,
  },
  {
    id: 'end-at',
    name: 'Bitiş',
    accessor: (row) => <DateColumn value={row.endAt} />,
  },
  {
    id: 'is-active',
    name: 'Durum',
    accessor: (row) => <BoolColumn value={row.isActive} />,
    align: 'center',
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type OffersTableProps = {
  offers: Offer[];
};

export const OffersTable = (props: OffersTableProps) => {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const paginatedRows = useMemo(
    () => paginateRows(props.offers, limit, page),
    [props.offers, limit, page],
  );

  return (
    <DataTable
      columns={columns}
      totalCount={props.offers.length}
      rows={paginatedRows}
      limit={limit}
      setLimit={setLimit}
      page={page}
      setPage={setPage}
      rowColorizer={rowColorizer}
      onClick={(offer) => navigate(`/sales/offers/${offer.id}`)}
    />
  );
};
